/* Wrapper for React Boostrap Overlay Trigger component
 * https://react-bootstrap.github.io/components.html#popovers
 *
 * The purpose of OverlayTrigger is to allow for any type of overlay,
 * this could be a Menu, Tooltip, Popover, Modal, etc..
 */

import React from 'react';
import PropTypes from 'prop-types';
import BootstrapOverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import classNames from 'classnames/dedupe';

export default class OverlayTrigger extends React.Component {

  constructor(props) {
    super(props);
    this.onOverlayOpen = this.onOverlayOpen.bind(this);
    this.onOverlayClose = this.onOverlayClose.bind(this);
    this.triggerClose = this.triggerClose.bind(this);
    this.getBoostrapInstance = this.getBoostrapInstance.bind(this);
    this.state = { active: false };
  }

  onOverlayOpen() {
    this.setState({ active: true });
  }

  onOverlayClose() {
    this.setState({ active: false });
  }

  /* bootstrapInstance is the instance of the <BootstrapOverlayTrigger> which
   * is needed in order to hide the Overlay when anything is clicked inside of it
   */
  getBoostrapInstance(bootstrapInstance) {
    this.setState({ bootstrapInstance });
  }

  triggerClose() {
    const { bootstrapInstance } = this.state;
    bootstrapInstance.hide();
  }

  render() {
    const { children, overlay, innerClose, ...others } = this.props;
    const { active } = this.state;
    const triggerProps = { className: classNames({ active }, children.props.className) };
    const trigger = React.cloneElement(children, triggerProps);

    let clonedOverlay = overlay;
    if (innerClose) {
      // Used to close the Overlay when any action inside of it is clicked.
      clonedOverlay = React.cloneElement(overlay, { onClick: this.triggerClose });
    }

    return (
      <BootstrapOverlayTrigger
        onEnter={this.onOverlayOpen}
        onExit={this.onOverlayClose}
        {...others}
        animation
        overlay={clonedOverlay}
        ref={this.getBoostrapInstance}
      >
        { trigger }
      </BootstrapOverlayTrigger>
    );
  }
}

OverlayTrigger.propTypes = {
  /** Specify which action or actions trigger Overlay visibility */
  trigger: PropTypes.oneOfType([
    PropTypes.oneOf(['click', 'hover', 'focus']),
    PropTypes.arrayOf(PropTypes.oneOf(['click', 'hover', 'focus']))
  ]),
  /** An element or text to overlay next to the target. */
  overlay: PropTypes.node.isRequired,
  /** Specify where the overlay will be rendered in relation to the target. */
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  /** Specify whether the overlay should trigger onHide when the user clicks
    * outside the overlay.
    */
  rootClose: PropTypes.bool,
  /** Specify whether the overlay should trigger onHide when the user clicks
    * inside the overlay.
    */
  innerClose: PropTypes.bool,
  /** The target element. */
  children: PropTypes.node.isRequired
};

OverlayTrigger.defaultProps = {
  trigger: ['hover', 'focus'],
  placement: 'bottom',
  rootClose: true,
  innerClose: true
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/OverlayTrigger.jsx